/**
 * Format a booked hourly rate for display (Completed Shift, etc.).
 * Matches app convention: `$45/hr` for whole dollars, `$42.5/hr` for decimals.
 */
export function formatHourlyRateDisplay(
  rate: number | string | null | undefined,
): string | null {
  if (rate === null || rate === undefined || rate === '') {
    return null;
  }
  const n = Number(rate);
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  return `$${n}/hr`;
}
